var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.6125 0 0 5.6125 0 12.5C0 19.3875 5.6125 25 12.5 25C19.3875 25 25 19.3875 25 12.5C25 5.6125 19.3875 0 12.5 0ZM16.7 15.375C17.0625 15.7375 17.0625 16.3375 16.7 16.7C16.5125 16.8875 16.275 16.975 16.0375 16.975C15.8 16.975 15.5625 16.8875 15.375 16.7L12.5 13.825L9.625 16.7C9.4375 16.8875 9.2 16.975 8.9625 16.975C8.725 16.975 8.4875 16.8875 8.3 16.7C7.9375 16.3375 7.9375 15.7375 8.3 15.375L11.175 12.5L8.3 9.625C7.9375 9.2625 7.9375 8.6625 8.3 8.3C8.6625 7.9375 9.2625 7.9375 9.625 8.3L12.5 11.175L15.375 8.3C15.7375 7.9375 16.3375 7.9375 16.7 8.3C17.0625 8.6625 17.0625 9.2625 16.7 9.625L13.825 12.5L16.7 15.375Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgClose);
export default __webpack_public_path__ + "static/media/img_close.a4255b9c954cfcd84eebf26d74de3e26.svg";
export { ForwardRef as ReactComponent };